import React from 'react';

function ImportPanel({
  importFile,
  importing,
  importResult,
  onFileChange,
  onImport,
}) {
  return (
          <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Importer des données depuis Google Forms</h2>
            
            <div className="space-y-6">
            

              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                <input
                  type="file"
                  accept=".csv,.json"
                  onChange={onFileChange}
                  className="hidden"
                  id="file-upload"
                />
                <label
                  htmlFor="file-upload"
                  className="cursor-pointer flex flex-col items-center"
                >
                  <svg className="w-16 h-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                  </svg>
                  <span className="text-lg font-medium text-gray-700 mb-2">
                    {importFile ? importFile.name : 'Cliquez pour sélectionner un fichier CSV ou JSON'}
                  </span>
                  <span className="text-sm text-gray-500">
                    Formats acceptés: .csv, .json
                  </span>
                </label>
              </div>

              {importFile && (
                <div className="flex justify-center">
                  <button
                    onClick={onImport}
                    disabled={importing}
                    className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                      importing
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-blue-500 hover:bg-blue-600 text-white'
                    }`}
                  >
                    {importing ? 'Import en cours...' : 'Importer les données'}
                  </button>
                </div>
              )}

              {importResult && (
                <div className={`rounded-lg p-4 ${
                  importResult.errors > 0 && importResult.imported === 0
                    ? 'bg-red-50 border border-red-200'
                    : importResult.imported > 0
                    ? 'bg-green-50 border border-green-200'
                    : 'bg-yellow-50 border border-yellow-200'
                }`}>
                  <h3 className={`text-lg font-semibold mb-2 ${
                    importResult.errors > 0 && importResult.imported === 0
                      ? 'text-red-800'
                      : importResult.imported > 0
                      ? 'text-green-800'
                      : 'text-yellow-800'
                  }`}>
                    Résultat de l'import
                  </h3>
                  <div className="space-y-2">
                    <p className={`font-medium ${
                      importResult.errors > 0 && importResult.imported === 0
                        ? 'text-red-700'
                        : importResult.imported > 0
                        ? 'text-green-700'
                        : 'text-yellow-700'
                    }`}>
                      {importResult.imported} candidature(s) importée(s) sur {importResult.total}
                    </p>
                    {importResult.errors > 0 && (
                      <div className="space-y-1">
                        {importResult.duplicates > 0 && (
                          <p className="text-orange-700">
                            {importResult.duplicates} candidature(s) déjà existante(s) (ignorée(s))
                          </p>
                        )}
                        {importResult.otherErrors > 0 && (
                          <p className="text-red-700">
                            {importResult.otherErrors} autre(s) erreur(s) rencontrée(s)
                          </p>
                        )}
                        {!importResult.duplicates && !importResult.otherErrors && (
                          <p className="text-red-700">
                            {importResult.errors} erreur(s) rencontrée(s)
                          </p>
                        )}
                      </div>
                    )}
                    {importResult.errorDetails && importResult.errorDetails.length > 0 && (
                      <div className="mt-4">
                        <p className="font-medium text-red-700 mb-2">Détails des erreurs :</p>
                        <ul className="list-disc list-inside space-y-1 text-sm text-red-600 max-h-40 overflow-y-auto">
                          {importResult.errorDetails.slice(0, 10).map((error, index) => (
                            <li key={index}>{error}</li>
                          ))}
                          {importResult.errorDetails.length > 10 && (
                            <li className="text-gray-500 italic">... et {importResult.errorDetails.length - 10} autres erreurs similaires</li>
                          )}
                        </ul>
                      </div>
                    )}
                    {importResult.availableColumns && importResult.availableColumns.length > 0 && (
                      <div className="mt-4 p-3 bg-gray-50 border border-gray-200 rounded">
                        <p className="font-medium text-gray-700 mb-2">📋 Colonnes détectées dans le fichier :</p>
                        <div className="flex flex-wrap gap-2">
                          {importResult.availableColumns.map((col, index) => (
                            <span key={index} className="px-2 py-1 bg-white border border-gray-300 rounded text-xs text-gray-600">
                              {col}
                            </span>
                          ))}
                        </div>
                        <p className="text-xs text-gray-500 mt-2">
                          💡 Si les colonnes ne correspondent pas, vérifiez que les noms de colonnes dans votre CSV contiennent les mots-clés attendus (nom, prénom, téléphone, etc.)
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
  );
}

export default ImportPanel;
